export default __webpack_public_path__ + "static/media/sponsored.598edd1b664e61272a4c83d995498e2b.svg";